import { FC } from 'react'
import { cn } from '@wellesley/ui'
import { LucideIcon } from 'lucide-react'
import { AppsLink, AppsRoutes } from '@wellesley/router'

export type LinkItemProps = {
  Icon: FC<{ className?: string }> | LucideIcon
  isActive: boolean
  link: string
  className?: string
  hasNotification?: boolean
  onClick?: () => void
  variant?: 'default' | 'notification'
}

export const LinkItem = ({
  Icon,
  link,
  isActive,
  className,
  hasNotification,
  variant = 'default',
}: LinkItemProps) => (
  <div
    className={cn(
      'relative cursor-pointer rounded-md p-2',
      ' hover:bg-slate-100',
      variant === 'notification' && isActive ? 'bg-blue-500 text-white' : '',
      className,
    )}
  >
    <AppsLink to={link as AppsRoutes}>
      {hasNotification && (
        <span
          className={cn(
            'absolute rounded-full bg-red-500',
            isActive ? 'right-2 top-1 h-2 w-2' : 'right-1 top-0.5 h-2 w-2',
          )}
        ></span>
      )}
      <Icon
        className={cn(
          'h-5 w-5',
          variant === 'default'
            ? isActive
              ? 'text-blue-500'
              : 'hover:text-blue-500'
            : variant === 'notification'
              ? isActive
                ? 'text-white'
                : 'hover:text-blue-500'
              : '',
        )}
      />
    </AppsLink>
  </div>
)
